import { makeStub } from "./_base";
export const BatchStock = makeStub("BatchStock");
